import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDKULDNmJ9MrTUKEiQKQMrNlCN07qh4nIY",
  authDomain: "gpstracker-b43ad.firebaseapp.com",
  databaseURL: "https://gpstracker-b43ad-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "gpstracker-b43ad",
  storageBucket: "gpstracker-b43ad.firebasestorage.app",
  messagingSenderId: "469762073153",
  appId: "1:469762073153:web:ea0b6851e403b226221cc0"
};

const app = initializeApp(firebaseConfig);

// Services
export const auth = getAuth(app);
export const db = getFirestore(app);